module.exports = "images/PolitiqueDeConfidentialite.4f2bd2e8.png";